<h5 class="mt-2">Dettaglio Quote</h5>
<div class="detail-box">
  <div class="detail-item">
    <p class="detail-label">{{ counterValueLabel }}</p>
    <h6>
      {{ counterValue | currency: 'EUR' }}
    </h6>
    <ng-template #detailDefaultValue>
      <h6>N/A</h6>
    </ng-template>
  </div>
    <app-basic-form
      id="datepicker-filters"
      [form]="form"
      [keys]="formKeys"
    ></app-basic-form>
  <table aria-label="quote-table" class="table" *ngIf="isQuoteTableHidden">
    <thead class="bg-light">
      <tr>
        <th scope="col">Fondo</th>
        <th scope="col">Totale numero quote</th>
        <th scope="col">Valore quota</th>
        <th scope="col">Controvalore</th>
        <th scope="col">Ultima quotazione</th>
        <th scope="col">Fonte iscritto</th>
        <th scope="col">Fonte datore</th>
        <th scope="col">Fonte TRF</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let share of quotesToShow">
        <tr>
          <td>{{ share.fundName }}</td>
          <td>{{ share.shareNumber }}</td>
          <td>{{ share.shareValue }}</td>
          <td>{{ share.controvalore | currency: 'EUR' }}</td>
          <td>
            {{
              share.lastQuotation !== "N/A"
                ? (share.lastQuotation | date : "dd/MM/yyyy")
                : "N/A"
            }}
          </td>
          <td>{{ share.subscriberAmount }}</td>
          <td>{{ share.employerAmount }}</td>
          <td>{{ share.TRFamount }}</td>
        </tr>
      </ng-container>
    </tbody>
  </table>
  <!-- <div class="detail-item">
    <p class="detail-label">{{ counterValueLabel }}</p>
    <h6>
      {{ counterValue }}
    </h6>
    <ng-template #detailDefaultValue>
      <h6>N/A</h6>
    </ng-template>
  </div> -->
</div>
